// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabsCompoMainDM {
  border-radius: 8px 8px 0 0;
  overflow-y: auto;
  height: 100%;
}
.tabsCompoMainDM table td:after {
  width: 0;
}
.tabsCompoMainDM .awm-job-seperator + .awm-job-seperator {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #595959;
}
.tabsCompoMainDM table > tbody > tr > td .mddm-tab-edit-icon {
  margin-left: 10px;
  height: 20px;
  cursor: pointer;
  font-size: 2rem;
  color: #003da5;
  width: 18px;
  height: 18px;
}
.tabsCompoMainDM .columnWidth {
  width: 320px;
}
.tabsCompoMainDM .accordion {
  margin: 0;
  height: 100%;
}
.tabsCompoMainDM .accordion .accordion-item {
  overflow: hidden;
}
.tabsCompoMainDM .accordion .accordion-item .accordion-header:has(.collapsed) {
  background-color: rgb(255, 239, 216);
}
.tabsCompoMainDM .accordion .accordion-item .accordion-header {
  background-color: rgb(214, 236, 255);
  border-radius: 4px 4px 0 0 !important;
}
.tabsCompoMainDM .accordion.accordion-flush .accordion-collapse {
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;
}
.tabsCompoMainDM .accordion .accordion-body {
  padding: 0px;
}
.tabsCompoMainDM .accordion .accordion-button {
  box-shadow: none;
  outline: none;
  padding-left: 30px;
  font-size: 14px;
  color: #003da5;
  width: fit-content;
  margin-right: 2px;
  width: 100%;
  padding: 8px;
}
.tabsCompoMainDM .accordion .accordion-button::after {
  right: 20px;
  position: absolute;
}
.tabsCompoMainDM .accordion .accordion-button:not(.collapsed) {
  background: rgb(214, 236, 255);
  color: #003da5;
}
.tabsCompoMainDM .accordion .pmp-details .accordion-button {
  background-color: #d6ecff !important;
}
.tabsCompoMainDM .accordion .pmp-details .columnWidth {
  background-color: #f3f3f3 !important;
}
.tabsCompoMainDM .accordion .mapping .accordion-button {
  background-color: #ffefd8 !important;
}
.tabsCompoMainDM .accordion .mapping .columnWidth {
  background-color: #fff8ee !important;
}
.tabsCompoMainDM .accordion .dsm-fields .accordion-button {
  background-color: #d3e4ff !important;
}
.tabsCompoMainDM .accordion .dsm-fields .columnWidth {
  background-color: #e9f1ff !important;
}
.tabsCompoMainDM .accordion .collapsed {
  background-color: rgb(255, 239, 216);
}
.tabsCompoMainDM .accordion .predecessor-select {
  min-width: 208px;
}

.p-tabview-title span {
  display: inline-block;
  padding: 5px;
}
.p-tabview-title span.pmpDes:first-letter {
  margin-right: 7px;
}

.cicinfoicontab {
  width: 24px;
  height: 24px;
  padding-left: 5px !important;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/DSBP/DMPMPSpecificTabView/index.scss"],"names":[],"mappings":"AAAA;EAEE,0BAAA;EACA,gBAAA;EACA,YAAA;AAAF;AACE;EACE,QAAA;AACJ;AACE;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;AACJ;AAEI;EACE,iBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAAN;AAIE;EACE,YAAA;AAFJ;AASE;EACE,SAAA;EACA,YAAA;AAPJ;AAQI;EAEE,gBAAA;AAPN;AAQM;EACE,oCAAA;AANR;AAQM;EACE,oCAAA;EACA,qCAAA;AANR;AASI;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AAPN;AASI;EACE,YAAA;AAPN;AASI;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAEA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AARN;AASM;EACE,WAAA;EACA,kBAAA;AAPR;AASM;EACE,8BAAA;EACA,cAAA;AAPR;AAUI;EACE,oCAAA;AARN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,oCAAA;AATN;AAWI;EACE,gBAAA;AATN;;AAeE;EACE,qBAAA;EACA,YAAA;AAZJ;AAcI;EACE,iBAAA;AAZN;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAdF","sourcesContent":[".tabsCompoMainDM {\n  // background-color: #eaecea;\n  border-radius: 8px 8px 0 0;\n  overflow-y: auto;\n  height: 100%;\n  table td:after {\n    width: 0;\n  }\n  .awm-job-seperator + .awm-job-seperator {\n    padding-top: 5px;\n    margin-top: 5px;\n    border-top: 1px solid #595959;\n  }\n  table > tbody > tr > td {\n    .mddm-tab-edit-icon {\n      margin-left: 10px;\n      height: 20px;\n      cursor: pointer;\n      font-size: 2rem;\n      color: #003da5;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .columnWidth {\n    width: 320px;\n    // background-color: #EDF4FA;\n  }\n\n  // .accordion .accordion-item .accordion-header:first-child {\n  //   border-radius: 4px 4px 0 0;\n  // }\n  .accordion {\n    margin: 0;\n    height: 100%;\n    .accordion-item {\n      // height: 100%;\n      overflow: hidden;\n      .accordion-header:has(.collapsed) {\n        background-color: rgba(255, 239, 216, 1);\n      }\n      .accordion-header {\n        background-color: rgba(214, 236, 255, 1);\n        border-radius: 4px 4px 0 0 !important;\n      }\n    }\n    &.accordion-flush .accordion-collapse {\n      height: 100%;\n      overflow: auto;\n      padding-bottom: 20px;\n    }\n    .accordion-body {\n      padding: 0px;\n    }\n    .accordion-button {\n      box-shadow: none;\n      outline: none;\n      padding-left: 30px;\n      font-size: 14px;\n      color: #003da5;\n      // background-color: red !important;\n      width: fit-content;\n      margin-right: 2px;\n      width: 100%;\n      padding: 8px;\n      &::after {\n        right: 20px;\n        position: absolute;\n      }\n      &:not(.collapsed) {\n        background: rgba(214, 236, 255, 1);\n        color: #003da5;\n      }\n    }\n    .pmp-details .accordion-button {\n      background-color: #d6ecff !important;\n    }\n\n    .pmp-details .columnWidth {\n      background-color: #f3f3f3 !important;\n    }\n    .mapping .accordion-button {\n      background-color: #ffefd8 !important;\n    }\n    .mapping .columnWidth {\n      background-color: #fff8ee !important;\n    }\n    .dsm-fields .accordion-button {\n      background-color: #d3e4ff !important;\n    }\n    .dsm-fields .columnWidth {\n      background-color: #e9f1ff !important;\n    }\n    .collapsed {\n      background-color: rgba(255, 239, 216, 1);\n    }\n    .predecessor-select {\n      min-width: 208px;\n    } \n  }\n}\n\n.p-tabview-title {\n  span {\n    display: inline-block;\n    padding: 5px;\n\n    &.pmpDes:first-letter {\n      margin-right: 7px;\n    }\n  }\n}\n\n.cicinfoicontab{\n  width: 24px ;\n  height: 24px;\n  padding-left: 5px !important;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
